import { render, staticRenderFns } from "./detectionDjc.vue?vue&type=template&id=397ccd73&scoped=true&"
import script from "./detectionDjc.vue?vue&type=script&lang=js&"
export * from "./detectionDjc.vue?vue&type=script&lang=js&"
import style0 from "./detectionDjc.vue?vue&type=style&index=0&id=397ccd73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397ccd73",
  null
  
)

export default component.exports